<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="举报原因">
          <el-input placeholder="请输入举报原因" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item label="是否解封/封禁">
          <el-select v-model="formInline.status" placeholder="请选择">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="解封/上架" value="1"></el-option>
            <el-option label="封禁/下架" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>
<!-- 
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加举报处理</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="remark" label="举报对象">

              <template slot-scope="scope">
                <div v-if="scope.row.type == 'user'" @click="jump('/user/user/index',scope.row.val.id)">
                    用户：<a style="color: blue;">{{ scope.row.val.name }}</a>
                </div>
                <div v-if="scope.row.type == 'notes'"  @click="jump('/plus/notes/index',scope.row.val.id)">
                    笔记：<a style="color: blue;">{{ scope.row.val.name }}</a>
                </div>
              </template>

            </el-table-column>

            <el-table-column prop="remark" label="举报原因"></el-table-column>

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column label="解封/封禁" width="250">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" 
                  active-color="#13ce66" inactive-color="#ff4949"
                  active-text="解封/上架" inactive-text="封禁/下架"
                  :active-value="1" :inactive-value="0"
                  @change="handleBlur(scope.row,'status')"
                  style="width: 300px;"
                ></el-switch>
            </template>

            </el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">查看详情</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :report_id="report_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import ReportApi from '@/api/report.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/ 
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          status:"-1",
        },

        open_add:false,
        open_edit:false,
        report_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      jump(url,id){
        let self = this;
        self.$router.push({
          path: url,
          query: {
            id: id,
            type:"index"
          }
        })
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//举报处理标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        ReportApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.report_id = row.report_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            ReportApi.del(
              {
                report_id: row.report_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      handleBlur(row,key){
        var self = this;
        ReportApi.editPart(
              {
                report_id: row.report_id,
                id:row.val.id,
                type:row.type,
                status:row.status,

              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '操作成功',
                    type: 'success'
                  });
  
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });

      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/report/index/index.vue